import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserCto } from 'src/app/api/models';
import { PersonService } from 'src/app/api/services';

@Component({
    selector: 'app-user-association-dialog',
    templateUrl: './user-association-dialog.component.html',
    styleUrls: ['./user-association-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserAssociationDialogComponent {
    private readonly dialogRef = inject<MatDialogRef<UserAssociationDialogComponent>>(MatDialogRef);
    private readonly personService = inject(PersonService);
    private readonly snackbar = inject(MatSnackBar);
    readonly data = inject<{
        personGuid: string;
        currentUser?: UserCto;
    }>(MAT_DIALOG_DATA);

    selectedUser?: UserCto;
    loading = false;

    onUserSelected(user: UserCto): void {
        this.selectedUser = user;
    }

    updateAssociation(): void {
        if (!this.selectedUser) return;

        this.loading = true;
        this.personService.updateUserAssociation$Json({
            personGuid: this.data.personGuid,
            body: { userGuid: this.selectedUser.userGuid, removeAssociation: false }
        }).subscribe({
            next: (result) => {
                this.loading = false;
                this.snackbar.open('User association updated successfully', 'Dismiss', { duration: 3000 });
                this.dialogRef.close(result);
            },
            error: (error) => {
                this.loading = false;
                const errorMessage = error?.error?.message || error?.message || 'An error occurred';
                this.snackbar.open(`Error: ${errorMessage}`, 'Dismiss');
            }
        });
    }

    removeAssociation(): void {
        this.loading = true;
        this.personService.updateUserAssociation$Json({
            personGuid: this.data.personGuid,
            body: { userGuid: null, removeAssociation: true }
        }).subscribe({
            next: (result) => {
                this.loading = false;
                this.snackbar.open('User association removed successfully', 'Dismiss', { duration: 3000 });
                this.dialogRef.close(result);
            },
            error: (error) => {
                this.loading = false;
                const errorMessage = error?.error?.message || error?.message || 'An error occurred';
                this.snackbar.open(`Error: ${errorMessage}`, 'Dismiss');
            }
        });
    }

    cancel(): void {
        this.dialogRef.close();
    }
}
